"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Cell = require("./Cell");
Object.keys(_Cell).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Cell[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Cell[key];
    }
  });
});